import React, { useState, useEffect } from "react";

import CommonSlider from "../Common/CommonSidebar/CommonSidebar";
import CommonHeader from "../Common/CommonHeader/CommonHeader";
import Routes from "../Routes";

const AdminLayout = ({
  themeMode,
  themeColor,
  borderStroke,
  boxLayout,
  monochrome,
  borderRadius,
  iconColor,
  gradientColor,
}) => {
  const [sidebarMini, setSidebarMini] = useState(false);
  const [sidebarHidden, setSidebarHidden] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
    if (window.innerWidth < 992) {
      setSidebarHidden(true);
    } else {
      setSidebarHidden(false);
    }
  };

  const toggleSidebar = () => {
    if (windowWidth > 991) {
      setSidebarMini((prevState) => !prevState);
    } else {
      setSidebarHidden((prevState) => !prevState);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [windowWidth]);

  return (
    // x---------------------------------x Dynamic Body SideBar and Header Code  x---------------------------------x
    <div
      data-theme={`theme-${themeColor}`}
      data-bs-theme={themeMode}
      className={`main_body ${gradientColor} ${borderStroke} ${boxLayout} ${monochrome} ${borderRadius}  ${sidebarMini ? "sidebar-mini" : ""} ${sidebarHidden ? "sidebar-hide" : ""}`}
    >
      <main
        className={`${boxLayout === "box-layout"
          ? "container"
          : "container-fluid"
          } px-0 ${sidebarMini ? "rightbar-mini" : ""} ${sidebarHidden ? "rightbar-hide" : ""}`}
      >
        {/* // x---------------------------------x CommonSideBar Section x---------------------------------x */}
        <CommonSlider
          iconColor={iconColor}
          toggleSidebarMobile={toggleSidebar}
        />
        <div className="content">
          {/* // x---------------------------------x CommonHeader Section x---------------------------------x */}
          <CommonHeader dynamicClass={"sidebar-toggle-btn"} MenuShow={true} toggleSidebar={toggleSidebar} toggleSidebarMobile={toggleSidebar} />
          <div className="px-2 py-sm-3 py-1 page-body">
            {/* // x---------------------------------x All Pages Routes x---------------------------------x */}
            <Routes />
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
